
namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class TestGroupGrid extends SiteEntityGrid<TestGroupRow, any> {
        protected getColumnsKey() { return 'Data.TestGroup'; }
        protected getDialogType() { return TestGroupDialog; }
        protected getIdProperty() { return TestGroupRow.idProperty; }
        protected getLocalTextPrefix() { return TestGroupRow.localTextPrefix; }
        protected getService() { return TestGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        getColumns() {
            var columns = super.getColumns();


            var batch = Q.tryFirst(columns, x => x.field === TestGroupRow.Fields.LastRunBatchId);
            if (batch) {
                batch.format = ctx => {
                    if (!ctx.value)
                        return "";

                    return `<a href="${Q.resolveUrl("~/Data/TestResult")}?batch=${ctx.value}">${Q.htmlEncode(ctx.value)}</a>`;
                }
            }

            columns.splice(3, 0, {
                field: 'Run',
                name: '',
                width: 35,
                minWidth: 35,
                maxWidth: 35,
                format: ctx => `<a class="inline-action run" title="run test group"><i class="fa fa-play-circle-o"></i></a>`,
                headerFilterType: Serenity.HeaderFilterType.disabled
            });

            return columns;
        }

        protected onClick(e, row, cell) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as TestGroupRow;
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('run')) {
                    TestGroupService.Run({
                        TestGroupCode: item.TestGroupCode
                    }, () => {
                        Q.notifyInfo("Running test group " + item.TestGroupCode);
                        this.refresh()
                    });
                }
            }
        }
    }
}